export default async (args = {}) => {
  return await axios.get('site/boas')
}